import i18n from '@/locale/i18n'

import easter from '@/page/easter/index'
import easterSuccess from '@/page/easter/success'

export default [
  {
    path: '/easter',
    component: easter,
    meta: { title: i18n.t('easter.title1') }
  },
  {
    path: '/easterSuccess',
    component: easterSuccess,
    meta: { title: i18n.t('easter.title2') }
  }
]



// WEBPACK FOOTER //
// ./src/router/easter/index.js